document.addEventListener("DOMContentLoaded", function() {
  const postcodeSearch = document.querySelectorAll("[data-postcode-search]");

  if (postcodeSearch.length > 0) {
    postcodeSearch.forEach((p) => {
      let results = [];
      let currentIndex = -1;
      const countryCode = p.dataset.countryCode ? p.dataset.countryCode : 'AU';
      const baseUrl = p.dataset.baseUrl;
      const input = p.querySelector("[data-postcode-search-input]");
      const dropdown = p.querySelector("[data-postcode-search-dropdown]");
      if (input && dropdown) {
        // Handle input event
        input.addEventListener("input", function() {
          fetchResults(this.value.trim(), baseUrl, countryCode);
        });

        // Handle keyboard navigation
        input.addEventListener("keydown", function(e) {
          const items = dropdown.querySelectorAll("div");

          if (e.key === "ArrowDown") {
            currentIndex = (currentIndex + 1) % items.length;
            updateActive(items);
          } else if (e.key === "ArrowUp") {
            currentIndex = (currentIndex - 1 + items.length) % items.length;
            updateActive(items);
          } else if (e.key === "Enter" && currentIndex > -1) {
            e.preventDefault();
            selectSuggestion(items[currentIndex]);
          }
        });

        // Handle click selection
        dropdown.addEventListener("click", function(e) {
          if (e.target.tagName === "DIV") {
            selectSuggestion(e.target);
          }
        });
      }

      // Hide dropdown when clicking outside
      document.addEventListener("click", function(e) {
        if (!e.target.closest(".postcode-search-container")) {
          dropdown.style.display = "none";
        }
      });

      function updateActive(items) {
        items.forEach((item, i) => {
          item.classList.toggle("active", i === currentIndex);
          if (i === currentIndex) {
            item.scrollIntoView({ behavior: "smooth", block: "nearest" });
          }
        });
      }

      function selectSuggestion(selectedItem) {
        input.value = selectedItem.textContent.trim();
        dropdown.style.display = "none";
        $("[data-postcode-autopopulate] input").val(selectedItem.dataset.postcode);
      }

      // Function to fetch API results
      async function fetchResults(query, baseUrl, countryCode) {
        if (!query) {
          dropdown.style.display = "none";
          return;
        }

        try {
          const response = await fetch(
            `${baseUrl}/api/location/getPostCodes?countryCode=${countryCode}&search=${query}`
          );
          results = await response.json();

          if (!results.length) {
            dropdown.innerHTML = "<div>No results found</div>";
            dropdown.style.display = "block";
            return;
          }

          renderDropdown();
        } catch (error) {
          console.error("Error fetching results:", error);
        }
      }

      function renderDropdown() {
        dropdown.innerHTML = results
          .map(
            (item, index) => `
                        <div data-index="${index}" data-id="${
              item.id
            }" data-postcode="${item.postcode}" class="${index === 0 ? "active" : ""}"> 
                            ${item.locality}, ${item.state} ${item.postcode}
                        </div>
                    `
          )
          .join("");

        dropdown.style.display = "block";
        currentIndex = 0;
      }
    });
  }
});



// WEBPACK FOOTER //
// ./client/src/core/components/forms/postcode-search.js